import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      width: "95%",
      maxWidth: "320px",
      [theme.breakpoints.up("mobile")]: {
        width: "396px",
        maxWidth: "none",
      },
      "& .MuiSnackbarContent-root": {
        backgroundColor: theme.palette.secondary.main,
      },
      "& .MuiSnackbarContent-message": {
        display: "flex",
        alignItems: "center",
      },
    },
    message: {
      fontSize: theme.typography.pxToRem(11),
      [theme.breakpoints.up("mobile")]: {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    button: {
      color: theme.palette.primary.main,
      backgroundColor: "white",
      "&:hover": {
        "@media (hover: hover)": {
          color: theme.palette.primary.main,
          backgroundColor: "white",
        },
      },
    },
    link: {
      color: "white",
      textDecoration: "underline",
    },
  }),
  { name: "CookieBanner" },
);
